import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { ReceivedImagePayload } from '../../../types';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
import DesktopSelfieView from './desktop-selfie-view';
import useCameraPermission from './use-camera-permission';
const DesktopSelfie = () => {
  const $ = _c(21);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.id-doc.pages.desktop-selfie"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  const [state, dispatch] = useIdDocMachine();
  const {
    requirement,
    hasBadConnectivity,
    allowPdf
  } = state.context;
  const permissionState = useCameraPermission();
  let t1;
  if ($[1] !== dispatch) {
    t1 = payload => dispatch({
      type: "receivedImage",
      payload
    });
    $[1] = dispatch;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onComplete = t1;
  let t2;
  if ($[3] !== dispatch) {
    t2 = () => dispatch({
      type: "cameraStuck"
    });
    $[3] = dispatch;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleCameraStuck = t2;
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp2);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp3);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== allowPdf || $[12] !== handleCameraStuck || $[13] !== hasBadConnectivity || $[14] !== onComplete || $[15] !== permissionState || $[16] !== requirement || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
    t6 = <DesktopSelfieView permissionState={permissionState} cameraTitleCamera={t3} cameraTitlePreview={t4} cameraSubtitleCamera={t5} requirement={requirement} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} onComplete={onComplete} onCameraStuck={handleCameraStuck} />;
    $[11] = allowPdf;
    $[12] = handleCameraStuck;
    $[13] = hasBadConnectivity;
    $[14] = onComplete;
    $[15] = permissionState;
    $[16] = requirement;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default DesktopSelfie;
function _temp($) {
  return $.header.title.camera;
}
function _temp2($_0) {
  return $_0.header.title.preview;
}
function _temp3($_1) {
  return $_1.header.subtitle.camera;
}